// The email_aliases_attributes the settings page saves for the alias rows it edits.
//
// A row with an address that is already stored keeps that alias, whichever row it is in. A row
// with a new address keeps its own alias (the address was edited in place) unless another row
// keeps it. So an inbox that sends from an alias keeps it, and no stored address moves to another
// row, which would trip the unique index. Addresses are trimmed and lowercased, blanks and repeats
// are dropped, and every stored alias that no row keeps is destroyed.
export const emailAliasesAttributes = (savedAliases, rows) => {
  const saved = savedAliases || [];
  const savedIdByEmail = new Map(
    saved.map(({ id, email }) => [email.toLowerCase(), id])
  );

  const edited = [];
  (rows || []).forEach(({ id, email }) => {
    const address = (email || '').trim().toLowerCase();
    if (address && !edited.some(row => row.email === address)) {
      edited.push({ id, email: address });
    }
  });

  const keptIds = new Set(
    edited.map(({ email }) => savedIdByEmail.get(email)).filter(Boolean)
  );
  const kept = edited.map(({ id, email }) => {
    const savedId = savedIdByEmail.get(email);
    if (savedId) return { id: savedId, email };
    if (id && !keptIds.has(id)) {
      keptIds.add(id);
      return { id, email };
    }
    return { email };
  });

  const removed = saved
    .filter(({ id }) => !keptIds.has(id))
    .map(({ id }) => ({ id, _destroy: true }));

  return [...kept, ...removed];
};
